import { render } from "./CashBookReport.vue?vue&type=template&id=845cedda&scoped=true"
import script from "./CashBookReport.vue?vue&type=script&lang=js"
export * from "./CashBookReport.vue?vue&type=script&lang=js"

import "../inventory/inventoryReport.css?vue&type=style&index=0&id=845cedda&scoped=true&lang=css&external"
import "./accountingReport.css?vue&type=style&index=1&id=845cedda&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-845cedda"]])

export default __exports__